import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

export async function getReportsAPI() {
  const url = `${AWS_API_URL}/reports`;
  return getRequest(url, await authorize());
}
